import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import dayjs from 'dayjs'
import ReachBarChart from 'pages/Review/components/BarChart'
import React, { useState } from 'react'
import useSWR from 'swr'
import DateRange from '../OverviewChart/DateRange'
import { FormProvider, useForm } from 'react-hook-form'
// import { OverViewDatePicker } from '../DatePicker'
// import Header from '../LoyaltyMetric/Header'

function ReviewOverview() {
    const [params, setParams] = useState({ start: '', end: '' })
    const { data: stats } = useSWR(`dashboard/ratings?${params.start ? 'start=' + params.start : ''}${params.end ? '&end=' + params.end : ''}`)

    const getParam = value => {
        if (value[0]) { setParams({ ...params, start: dayjs(value[0]).format('YYYY-MM-DD') }) }
        if (value[1]) { setParams({ ...params, end: dayjs(value[1]).format('YYYY-MM-DD') }) }
    }
    const methods = useForm({ mode: 'all' })
    return (
        <div className='w-50 rounded-[16px] my-[24px] bg-white py-[20px] px-[28px]'>
            {/* <Header text={'Review Overview '} /> */}
            <div className='flex justify-between mt-4'>
                <div className='text-[#4F4F4F] text-[20px] font-[700]'>Review Overview </div>
                {/* <div className='relative'> */}
                {/* <ReachAfrikaDatePicker onChange={(data) => getParam(data)} /> */}
                <FormProvider {...methods}>
                    <DateRange name={'date_range'} className={'w-fit'} getRange={getParam} />
                </FormProvider>
                {/* </div> */}
            </div>
            <Box className='w-[100%] flex items-end justify-between h-[auto] my-[24px] py-2 '>
                <div className='flex  items-center lg:flex-row w-100 justify-between'>
                    <div className='lg:flex items-end xs:flex-col ' >
                        <Typography color='black' className='!my-0 !py-0' fontSize={{ xs: '20px', lg: '50px' }} lineHeight={'40px'} fontWeight={700}>{stats?.data?.rating || '0.0'} </Typography> <br />
                        <Typography fontWeight={'700'} color='black' className='lg:pl-2 xs:pl-0'>out of 5</Typography>
                        <Typography fontWeight={'700'} color='black' className='pl-[60px]'>{stats?.data?.total || 0}  Reviews</Typography>
                    </div>
                </div>
            </Box>
            <Box className=' flex  !items-center'>
                <ReachBarChart data={stats?.data?.data}
                    // top={'top-[210px]'}
                    reversed={true} />

            </Box>
        </div>
    )
}

export default ReviewOverview